import React from "react";
import { AccordionItemLabel, Section, StyledSectionTitle } from "./elements";
import { FAQData } from "../../api/mockData";
import { Accordion } from "../../components/Accordion";

export const FAQ: React.FC = React.memo(() => {
  return (
    <Section>
      {FAQData.map((item, index) => {
        return (
          <div>
            <StyledSectionTitle>{item.genre}</StyledSectionTitle>
            {item.qa.map((item) => {
              return (
                <Accordion
                  isSmall={false}
                  key={`accordion-item${index}`}
                  title={`Q. ${item.q}`}
                >
                  <AccordionItemLabel>A. {item.a}</AccordionItemLabel>
                </Accordion>
              );
            })}
          </div>
        );
      })}
    </Section>
  );
});

FAQ.displayName = "FAQ";
